import Button from "../../../../Elements/Button/Button.js";
import React, { useState } from "react";
import Icon from "../../../../Elements/Icon/Icon.tsx";
import { useContent } from "../../../../../contexts/contentContext/contentContext.js";
import Image from "../../../../Elements/Image/Image.tsx";
import parse from "html-react-parser";

const CreateEmbedPageModalSecondStep = ({
  companyName,
  userNameUrl,
  setLoadingPage,
  loadingPage,
  loadingNum,
  loadingCreatePage,
  createPage,
  setLoadingButton,
  loadingButton,
  dynamicFormsList = null,
}) => {
  const { getTextByKey } = useContent();
  const [displayFormList, setDisplayFormList] = useState(false);
  const [activeFormLists, setActiveFormLists] = useState([]);

  const createPageFunction = () => {
    setLoadingButton(true);
    createPage({ companyName, userNameUrl, setLoadingPage, activeFormLists });
  };

  const changeActiveFormList = (item) => {
    if (activeFormLists.includes(item.Embed_Dynamic_Id)) {
      setActiveFormLists(
        activeFormLists.filter((i) => i !== item.Embed_Dynamic_Id)
      );
    } else {
      setActiveFormLists([...activeFormLists, item.Embed_Dynamic_Id]);
    }
  };

  const getEmbedDynamicFormById = (id) => {
    return dynamicFormsList.find((i) => i.Embed_Dynamic_Id === id);
  };

  const removeForm = (id) => {
    setActiveFormLists(activeFormLists.filter((i) => i !== id));
  };

  return (
    <div className="create-page-modal-new">
      <div className="create-page-modal-header">
        <h1>{getTextByKey("select-forms")}</h1>
        <p>{parse(getTextByKey("select-forms-subtitle"))}</p>
      </div>
      <div className="inputs">
        <div className="form-list-dropdown">
          <div
            tabIndex={0}
            onClick={() => setDisplayFormList((prev) => !prev)}
            className="select-list"
          >
            <span>{getTextByKey("select-options")}</span>
            <Icon name={"arrow-down"} />
          </div>
          <div className={`form-list-ul ${displayFormList ? "show" : "hide"}`}>
            <ul>
              {dynamicFormsList &&
                dynamicFormsList.map((item, i) => (
                  <li key={i} onClick={() => changeActiveFormList(item)}>
                    <div className="content-form">
                      <div className="form-image">
                        <Image alt="" title="" src={item.Embed_Dynamic_Image} />
                      </div>
                      <span className="form-title">
                        {item.Embed_Dynamic_Inner_Title}
                      </span>
                    </div>
                    {activeFormLists.includes(item.Embed_Dynamic_Id) && (
                      <div className="active-form">
                        <Image
                          name="create-form/v-icon"
                          ext="svg"
                          alt=""
                          title=""
                        />
                      </div>
                    )}
                  </li>
                ))}
            </ul>
          </div>
          {activeFormLists.length > 0 && !displayFormList && (
            <div className="display-selected-forms">
              <ul>
                {activeFormLists.map((item, i) => (
                  <li key={i}>
                    <div className="content-form">
                      <div className="form-image">
                        <Image
                          alt=""
                          title=""
                          src={
                            getEmbedDynamicFormById(item).Embed_Dynamic_Image
                          }
                        />
                      </div>
                      <span className="form-title">
                        {
                          getEmbedDynamicFormById(item)
                            .Embed_Dynamic_Inner_Title
                        }
                      </span>
                    </div>
                    <div
                      className="remove-form"
                      onClick={() => removeForm(item)}
                    >
                      <Icon name="x" />
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
        {loadingPage ? (
          <div className="show-loading">
            <div className="circle-container">
              <span>{loadingNum}</span>
            </div>
          </div>
        ) : (
          <div className="submit-div">
            <Button onClick={() => createPageFunction()}>
              {loadingButton ? (
                <Image alt="" title="" name="preloader" ext="gif" />
              ) : (
                getTextByKey("create-page")
              )}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default CreateEmbedPageModalSecondStep;
